import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery/dist/jquery.min.js';

// Servicio
import { EmpleadosServicio } from '../../services/empleado.service';
import { AlertasModales } from '../../helpers/alertasModales';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  msg: string;
  logged = false;
  inputType = 'password';


    constructor(
        public empleadoServicio: EmpleadosServicio,
        private route: Router,
        private params: ActivatedRoute,
        private modals: AlertasModales
    ) {
        // Inicializar el formulario
        this.form = new FormGroup({
        usuario: new FormControl('', Validators.required),
        password: new FormControl('', [Validators.required, Validators.minLength(6)])
        });

        if (localStorage.getItem('token')) {
            this.route.navigate(['/inicio']);
        }
        if (localStorage.getItem('session')) {
            localStorage.getItem('session');
            this.msg = 'Tu sesión ha expirado';
        }

        this.params.queryParams.subscribe(res => {
            if (res.securityToken) {
                localStorage.setItem('token', res.securityToken);
                this.logged = true;
                setTimeout(() => {
                    this.route.navigate(['/inicio']);
                }, 4000);
            }
        });
    }

    ngOnInit() {
        //   Mostrar contraseña/Ocultar contraseña
        $('#showPass').click(() => {
            const self = $('#showPass');
            if (self.hasClass('fa-eye')) {
            // Cambiar icono eye
            self.removeClass('fa-eye');
            self.addClass('fa-eye-slash');
            self.attr('title', 'Ocultar contraseña');

            // Cambiar tipo de input
            $('#password').attr('type', 'text');
            } else {
                // Cambiar icono eye
            self.removeClass('fa-eye-slash');
            self.addClass('fa-eye');
            self.attr('title', 'Mostrar contraseña');

            // Cambiar tipo de input
            $('#password').attr('type', 'password');
            }
        });

        $('body').css('background-color',  'rgba(230, 230, 230, 0.55)');
    }

    // Autentificar empleado si el formulario es valido
    iniciarSesion() {
        this.msg = '';
        if (this.form.valid) {
            $('button:submit').html(`<i class='fa fa-circle-o-notch fa-spin'></i> Iniciando sesion`).prop('disabled', true);
            this.msg = '';

            this.empleadoServicio.iniciarSesion(this.form.value).subscribe((res: any) => {
                $('button:submit').html('Iniciar sesion').prop('disabled', false);

                if (res) {

                    // Crear localStorage con el token
                    localStorage.setItem('token', res);
                    this.logged = true;
                    setTimeout(() => {
                        this.route.navigate(['/inicio']);
                    }, 4000);
                }
            }, (err: any) => {
                $('button:submit').html('Iniciar sesion').prop('disabled', false);
                if (err && err.status === 0) {
                    this.msg = 'Ocurrió un error inesperado';
                } else {
                    this.msg = err.error;
                }
            });
        } else {
            this.msg = 'Usuario y contraseña son obligatorios';
        }
    }

    restablecerPass() {
        this.modals.restablecerContrasenaNgbModal().then(res => {
            if (res == 'ok') {
                this.modals.correctoModalJquery('Reestablecer contraseña',
                'green', 'modern', 'fa fa-lock', 'Hemos enviando un enlace a tu correo para proceder con el cambio de contraseña.');
            } else {
                this.modals.validacionesModalJquery('Error de validación', res.error, 'red', 'modern');
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/login/login.component.ts